import { render, staticRenderFns } from "./egym-workout-description.component.vue?vue&type=template&id=34020380&scoped=true"
import script from "./egym-workout-description.component.ts?vue&type=script&lang=ts&external"
export * from "./egym-workout-description.component.ts?vue&type=script&lang=ts&external"
import style0 from "./egym-workout-description.component.scss?vue&type=style&index=0&id=34020380&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34020380",
  null
  
)

export default component.exports